import { AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from '~/Store';

import ActionTypes from './ActionTypes';
import { Message, State } from './reducer';

export function flashErrorMessage(
	text: any = 'Something went wrong, please try again or refresh the page.'
): ThunkAction<void, any> {
	return (dispatch, getState) => {
		const message = {
			key: getState().flashMessages.counter,
			type: 'error',
			text,
			dismissable: true,
		};
		dispatch({ type: ActionTypes.add, message, timeout: null });
	};
}

export function flashWarningMessage(text: any, autoDismiss = true): ThunkAction<void, any> {
	return autoDismiss ? flashMessageWithTimeout(text, 'warning') : flashMessage(text, 'warning');
}

export function flashSuccessMessage(text: any): ThunkAction<void, { flashMessages: State; type: string }> {
	return flashMessageWithTimeout(text, 'success');
}

function flashMessageWithTimeout(text: any, type: string): ThunkAction<void, { flashMessages: State; type: string }> {
	return (dispatch) => {
		return dispatch(flashMessage(text, type, scheduleFlashMessageDismiss(dispatch)));
	};
}

function flashMessage(text: any, type: string, timeout?: NodeJS.Timeout | null): ThunkAction<void, any> {
	return (dispatch, getState) => {
		const message = {
			key: getState().flashMessages.counter,
			type,
			text,
			dismissable: true,
		};
		dispatch({ type: ActionTypes.add, message, timeout });
	};
}

function scheduleFlashMessageDismiss(dispatch: ThunkDispatch<AnyAction>): NodeJS.Timeout {
	const timeout: NodeJS.Timeout = setTimeout(() => dispatch({ type: ActionTypes.timeout, timeout }), 6 * 1000);
	return timeout;
}

export function removeFlashMessage(message: Message): AnyAction {
	return { type: ActionTypes.remove, message };
}

export function removeFlashMessageByText(text: string): AnyAction {
	return { type: ActionTypes.removeByText, text };
}

export function resetFlashMessages(): AnyAction {
	return { type: ActionTypes.reset };
}

export function cancelFlashMessagesDismiss(): AnyAction {
	return { type: ActionTypes.cancelDismiss };
}

export function scheduleFlashMessagesDismiss(): ThunkAction<void, any> {
	return (dispatch) => {
		const timeout = scheduleFlashMessageDismiss(dispatch);
		dispatch({ type: ActionTypes.scheduleDismiss, timeout });
	};
}
